import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import {
    Button,
    Card,
    CardBody,
    Col,
    CustomInput,
    Modal,
    ModalHeader,
    Row
} from "reactstrap";
import swal from "sweetalert";
import { api } from "../../_services/api.service";

const MetricSettings = ({
  partnerScenarioId,
  partnerMetricId,
  showModal,
  toggleModal,
  reloadList,
  useAltAPI
}) => {
  let defaultMetric = {
    partnerMetricID: -1,
    partnerScenarioID: partnerScenarioId,
    partnerMetricName: "",
    partnerMetricType: "Integer",
    inactive: false,
  };

  let [metric, setMetric] = useState(defaultMetric);
  let [isLoading, setIsLoading] = useState(false);

  const metricTypes = [
    { id: 1, type: "Integer" },
    { id: 2, type: "Decimal" },
    { id: 3, type: "ShortText" },
    { id: 4, type: "Currency" },
    { id: 5, type: "Image" },
    { id: 6, type: "Link" },
    { id: 7, type: "LongText" },
    { id: 8, type: "Document" },
    { id: 9, type: "Address (Map)" },
  ];

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  useEffect(() => {
    if (showModal && partnerMetricId > -1) {
      loadMetric(partnerMetricId);
    } else if (showModal) {
      setMetric({ ...defaultMetric, partnerScenarioID: partnerScenarioId });
    }
  }, [showModal, partnerMetricId]);

  const loadMetric = (id) => {
    if (id > 0) {
      setIsLoading(true);
      api.getPartnerMetricById(id).then((data) => {
        setMetric(data);
        setIsLoading(false);
      });
    }
  };

  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (metric.partnerMetricID > 0) {
        api.updatePartnerMetric(0, metric).then((data) => {
          toast("Data Item saved successfuly", successToastOpts);
          toggleModal();
          reloadList();
        });
      } else {
        let m = { ...metric };
        m.partnerScenarioID = partnerScenarioId;
        api.createPartnerMetric(0, m).then((id) => {
          toast("Data Item saved successfuly", successToastOpts);
          toggleModal();
          reloadList();
        });
      }
    }
  };

  const removeMetric = () => {
    swal({
      text: "Are you sure you want to remove this data item?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        let m = { ...metric };
        m.partnerScenarioID = partnerScenarioId;
        api.deletePartnerMetric(0, m).then((data) => {
          toggleModal();
          reloadList();
        });
      }
    });
  };

  const handleMetricTypeChanged = (metricType) => {
    setMetric({ ...metric, partnerMetricType: metricType });
  };

  return (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={() => toggleModal()}
      backdrop="static"
    >
      <ModalHeader toggle={() => toggleModal()}>Data item</ModalHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <AvField
                        name="partnerMetricName"
                        label="Data Item Name *"
                        value={metric.partnerMetricName}
                        onChange={(e) =>
                          setMetric({
                            ...metric,
                            partnerMetricName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />

                      <div className="form-group">
                        <label>Data Item Type</label>
                        <CustomInput
                          type="select"
                          id={`metricTypeSelect`}
                          value={metric.partnerMetricType}
                          className="form-control"
                          name={"metricType"}
                          onChange={(e) => {
                            handleMetricTypeChanged(e.target.value);
                          }}
                        >
                          {metricTypes.map((m) => {
                            return (
                              <option key={m.type} value={m.type}>
                                {m.type}
                              </option>
                            );
                          })}
                        </CustomInput>
                      </div>

                      {(metric.partnerMetricType === "Link" ||
                        metric.partnerMetricType === "Image") &&
                        <AvField
                          name="altAPITemplate"
                          label="API Template"
                          value={metric.altAPITemplate}
                          onChange={(e) =>
                            setMetric({
                              ...metric,
                              altAPITemplate: e.target.value.trim(),
                            })
                          }
                          placeholder="Enter..."
                        />}

                      {useAltAPI && <AvField
                        name="altAPIFieldName"
                        label="Corresponding API Node *"
                        value={metric.altAPIFieldName}
                        onChange={(e) =>
                          setMetric({
                            ...metric,
                            altAPIFieldName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />}

                      {(metric.partnerMetricType === "Address (Map)") &&
                        <AvField
                          name="altAPILatitudeField"
                          label="API Latitude Node"
                          value={metric.altAPILatitudeField}
                          onChange={(e) =>
                            setMetric({
                              ...metric,
                              altAPILatitudeField: e.target.value.trim(),
                            })
                          }
                          placeholder="Enter..."
                        />}

                      {(metric.partnerMetricType === "Address (Map)") &&
                        <AvField
                          name="altAPILongitudeField"
                          label="API Longitude Node"
                          value={metric.altAPILongitudeField}
                          onChange={(e) =>
                            setMetric({
                              ...metric,
                              altAPILongitudeField: e.target.value.trim(),
                            })
                          }
                          placeholder="Enter..."
                        />}
                    </Col>
                  </Row>
                  <div className="pull-right">
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                    >
                      Save
                    </Button>
                    {metric.partnerMetricID > 0 && (
                      <Button color="danger" onClick={() => removeMetric()}>
                        Delete
                      </Button>
                    )}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => toggleModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default MetricSettings;
